<template>
    <div class="d-flex flex-wrap flex-stack my-5">
        <router-link v-if="!$root.filterWithUrl" :to="sprintf('/system/notification/group/%d/sub-group', [groupID])" class="btn btn-primary align-self-center">
            <span class="svg-icon svg-icon-2">
                <inline-svg src="/media/icons/duotune/arrows/arr021.svg"/>
            </span>
            {{ $t("pages.system.notification.item.subGroup.title") }}
        </router-link>
    </div>
    <custom-table
        :title="sprintf($t('pages.system.notification.item.titlePattern'), [subGroup.translate.name ?? ''])"
        :subTitle="$t('pages.system.notification.item.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        selectableRows
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange">
        <template v-slot:status="{ row: record }">
            <span :class="record.active ? 'badge-light-success': 'badge-light-danger'" class="badge">{{ record.active ? $t('common.active') : $t('common.passive') }}</span>
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('pages.system.notification.item.template.title')" placement="top">
                    <router-link :to="sprintf('/system/notification/group/%d/sub-group/%d/item/%d/template', [groupID, subGroupID, record.id])" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                        <span class="svg-icon svg-icon-3">
                            <inline-svg src="/media/icons/duotune/text/txt009.svg"/>
                        </span>
                    </router-link>
                </el-tooltip>
                <a v-on:click="fetchRecord(record)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                    <span class="svg-icon svg-icon-3">
                        <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                    </span>
                </a>
                <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteRecord([record.id])">
                    <template #reference>
                        <a class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                            <span class="svg-icon svg-icon-3">
                                <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                            </span>
                        </a>
                    </template>
                </el-popconfirm>
            </div>
        </template>
    </custom-table>
    <div class="modal fade" id="kt_modal_item" ref="itemModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit()" :model="form.data" ref="itemForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_add_customer_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.system.notification.item.cols.name') }}</label>
                                <el-form-item prop="name" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.name" type="text"/>
                                </el-form-item>
                            </div>
                            <div class="fv-row mb-7">
                                <label class="fs-6 fw-bold mb-2">{{ $t('common.sort') }}</label>
                                <el-form-item prop="sort" :rules="$validation.getMessage(['required'])">
                                    <el-input-number v-model="form.data.sort" :min="1"/>
                                </el-form-item>
                            </div>
                            <div class="fv-row mb-10">
                                <label class="fs-6 fw-bold mb-2">{{ $t('common.status') }}</label>
                                <el-form-item prop="active">
                                    <el-radio-group v-model="form.data.active">
                                        <el-radio-button :label="true">{{ $t("common.active") }}</el-radio-button>
                                        <el-radio-button :label="false">{{ $t("common.passive") }}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "index",
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("common.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.system.notification.item.cols.name"),
                    key: "name"
                },
                {
                    name: this.$t("common.sort"),
                    key: "sort",
                    class: ""
                },
                {
                    name: this.$t("common.status"),
                    scopedSlots: {customRender: "status"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {}
            },
            subGroup: {
                translate: {}
            },
            selectedRowKeys: []
        }
    },
    computed: {
        groupID() {
            return this.$route.params.group_id;
        },
        subGroupID() {
            return this.$route.params.sub_group_id;
        },
        table() {
            return this.$store.state.notification.item.table;
        },
    },
    created() {
        if (!this.subGroupID || !(this.subGroupID > 0)) {
            this.$router.push({
                path: this.sprintf('/system/notification/group/%d/sub-group', [this.groupID])
            });
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("pages.system.notification.item.title"), [this.$t("menu.systemManagement"), this.$t("pages.system.notification.item.group.title")]);

        if (this.groupID && this.groupID > 0) {
            this.$store.dispatch('notification/item/get', {
                page: {},
                filterData: Object.assign(this.$root.getFilterWithUrl({}), {
                    sub_group_id: this.subGroupID
                })
            });

            this.loadGroup();
        }
    },
    methods: {
        loadGroup(){
            this.axios.get(this.endpoints['notification_item_sub_group'] + '/' + this.subGroupID).then((response) => {
                let data = response.data.data;
                data.translate = this.resolveDatum(data.translations, this.$root.defaultLanguage.id, 'language_id');

                this.subGroup = data;
            }).catch((error) => {
                if(error.response.data.message == 'record_not_found') {
                    this.$router.push({
                        path: this.sprintf('/system/notification/group/%d/sub-group', [this.groupID])
                    });
                }
            });
        },
        newRecord() {
            this.form.updateStatus = false;

            this.form.data = {
                sub_group_id: this.subGroupID,
                sort: 1,
                active: true
            };

            this.form.title = this.$t("pages.system.notification.item.new");

            this.showModal(this.$refs.itemModal);
        },
        fetchRecord(record) {
            this.form.updateStatus = true;
            this.axios.get(this.endpoints['notification_item'] + '/' + record.id).then(response => {
                let data = response.data.data;

                this.form.title = this.sprintf(this.$t("pages.system.notification.item.edit"), [data.title]);
                this.form.data = data;

                this.showModal(this.$refs.itemModal);
            });
        },
        onSubmit() {
            this.$refs.itemForm.validate((valid) => {
                if (valid) {
                    let formData = this.prepareFormData();

                    this.form.loading = true;

                    if (this.form.data.id) {
                        this.axios.put(this.endpoints['notification_item'] + '/' + formData.id, formData).then(response => {
                            this.onResponse(response.data, () => {
                                this.refreshTable();
                                this.hideModal(this.$refs.itemModal);
                            });
                        }).catch(error => {
                            this.onResponseFailure(error.response.data);
                        }).finally(() => {
                            this.form.loading = false;
                        });
                    } else {
                        this.axios.post(this.endpoints['notification_item'], formData).then(response => {
                            this.onResponse(response.data, () => {
                                this.refreshTable();
                                this.hideModal(this.$refs.itemModal);
                            });
                        }).catch(error => {
                            this.onResponseFailure(error.response.data);
                        }).finally(() => {
                            this.form.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        prepareFormData() {
            return this.cloneData(this.form.data);
        },
        deleteRecord(id) {
            this.$store.dispatch("notification/item/delete", {
                id: id
            }).then((successDeleted) => {
                this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
            });
        },
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    this.newRecord();
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        },
        refreshTable() {
            this.$store.dispatch("notification/item/refresh");
        },
        handleTableChange(pagination, filterData) {
            this.$store.dispatch("notification/item/get", {
                page: pagination,
                filterData: Object.assign({
                    sub_group_id: this.subGroupID
                }, filterData)
            });
        },
    }
}
</script>

<style>
</style>